import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FooterNavButtons from './FooterNavButtons';
import FooterNavRow from './FooterNavRow';

import styles from './footer.scss';
import footerSelector from '../../selectors/footer/FooterSelector';

const Footer = (props) => {
    const {
        isLargeTest,
        shouldRenderNavRow,
    } = props;

    const classList = [styles.footer];
    if (isLargeTest) {
        classList.push(styles.scrollableFooter);
    }

    return (
        <footer className={classList.join(' ')}>
            <FooterNavButtons {...props} />
            { shouldRenderNavRow && <FooterNavRow {...props} /> }
        </footer>
    );
};

Footer.propTypes = {
    isLargeTest: PropTypes.bool.isRequired,
    shouldRenderNavRow: PropTypes.bool.isRequired,
};

const mapStateToProps = state => footerSelector.selectProps(state);
export default connect(mapStateToProps)(Footer);
